import { render, staticRenderFns } from "./NotificationSubscriptionPurchase.vue?vue&type=template&id=c5403dd6&scoped=true&"
import script from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSubscriptionPurchase.vue?vue&type=style&index=0&id=c5403dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5403dd6",
  null
  
)

export default component.exports